import APP_CONFIG from '../../app-config/app-config';

import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Platform, AlertController } from 'ionic-angular';
import { AppVersion } from '@ionic-native/app-version';
import { NativeStorage } from '@ionic-native/native-storage';
// import { Pro } from "@ionic/pro";

// import { DeployUpdate } from '../methods/update-pro';

import 'rxjs/add/operator/map';
import { InAppBrowser } from '@ionic-native/in-app-browser';

// declare var window: any;
// declare var IonicCordova: any;

@Injectable()
export class UpdateService {
	currentVersion: string;
	latestVersion: string;

	isBinaryUpdateAvailable: boolean = false;
	isContentUpdateAvailable: boolean = false;

	private binaryUpdateChecked: boolean = false;
	private contentUpdateChecked: boolean = false;

	private forceUpdatePopupRegardlessOfDate: boolean = true;

	constructor(
		private http: Http,
		private platform: Platform,
		private appVersion: AppVersion,
		// private loadingController: LoadingController,
		private alertController: AlertController,
		private nativeStorage: NativeStorage,
		private inAppBrowser: InAppBrowser,
	) {
		this.init();
	}

	// check for updates on initialisation
	private init(): void {
		// console.log('update service init')

		this.platform.ready().then(() => {
			if (this.platform.is('cordova')) {
				// save current app version to variable
				this.appVersion.getVersionNumber().then((version) => {
					this.currentVersion = version;
				});

				// check for updates
				this.checkForUpdates();

				// when opening app from background - check for updates again
				this.platform.resume.subscribe(() => {
					this.forceUpdatePopupRegardlessOfDate = false;
					this.checkForUpdates();
				});
			}
		});
	}

	currentVersionString(prefix: boolean = true): string {
		return this.currentVersion ? `${prefix ? 'v' : ''}${this.currentVersion}` : '';
	}

	currentDeployVersionString(prefix: boolean = true): string {
		return APP_CONFIG.app_version ? `${prefix ? 'v' : ''}${APP_CONFIG.app_version}` : '';
	}

	latestVersionString(prefix: boolean = true): string {
		return this.latestVersion ? `${prefix ? 'v' : ''}${this.latestVersion}` : '';
	}

	private checkForUpdates(): void {
		if (APP_CONFIG.binary_updates) {
			this.checkForBinaryUpdate();
		}
		// if(!APP_CONFIG.is_electron && APP_CONFIG.content_updates) {
		// 	this.checkForContentUpdate();
		// }
	}

	private checkForBinaryUpdate(): void {
		if (!APP_CONFIG.binary_updates) {
			return;
		}

		console.log('GET LATEST VERSION');

		this.appVersion.getVersionNumber().then((version) => {
			// get the current time to force a cache bust
			let date = new Date().getTime();
			let versionURL = `https://apps.media4learning.co.nz/av/version.json?no-cache=${date}`;

			// get current binary version number from server
			this.http
				.get(versionURL)
				.map((res) => res.json())
				.subscribe(
					(res) => {
						this.latestVersion = this.platform.is('android') ? res.version_android : res.version_ios;
						console.log(`LATEST VERSION (${this.platform.is('android') ? 'android' : 'ios'}):`);
						console.log(this.latestVersion);
						console.log(version);

						// compare versions
						if (typeof this.latestVersion !== 'undefined' && this.latestVersion !== version) {
							// check if server version is newer than app version
							if (this.checkVersionIsNewer(version, this.latestVersion)) {
								this.isBinaryUpdateAvailable = true;
							}
						}

						this.binaryUpdateChecked = true;

						// check if update dialog needs to be shown
						this.updateDialogDateCheck();
					},
					(error) => {
						console.log(error);
					}
				);
		});
	}

	checkVersionIsNewer(oldVersion: string, newVersion: string): boolean {
		// split version into and array
		let oldVersionSplit: any = oldVersion.split('.');
		let newVersionSplit: any = newVersion.split('.');

		// convert split strings to integers
		let oldInts = oldVersionSplit.map((n) => {
			return parseInt(n);
		});
		let newInts = newVersionSplit.map((n) => {
			return parseInt(n);
		});

		var isNewer = false;

		// check if the server version is higher than the app version
		if (
			(newInts[0] || 0) > (oldInts[0] || 0) ||
			((newInts[0] || 0) >= (oldInts[0] || 0) && (newInts[1] || 0) > (oldInts[1] || 0)) ||
			((newInts[0] || 0) >= (oldInts[0] || 0) && (newInts[1] || 0) >= (oldInts[1] || 0) && (newInts[2] || 0) > (oldInts[2] || 0))
		) {
			isNewer = true;
		}

		return isNewer;
	}

	// private checkForContentUpdate(): void {
	// 	if (!APP_CONFIG.content_updates) {
	// 		return;
	// 	}

	// 	IonicCordova.deploy.init({
	// 		appId: APP_CONFIG.update_app_id,
	// 		channel: APP_CONFIG.update_channel_name
	// 	});

	// 	// check ionic for content updates
	// 	IonicCordova.deploy.check((res: any) => {
	// 		// if it returns "true" - an update is available
	// 		if (res && res === 'true') {
	// 			this.isContentUpdateAvailable = true;
	// 		}

	// 		this.contentUpdateChecked = true;

	// 		// check if update dialog needs to be shown
	// 		this.updateDialogDateCheck();
	// 	});
	// }

	// private async checkForContentUpdate() {
	// 	const update = await Pro.deploy.checkForUpdate();

  //   if(update.available) {
	// 		this.isContentUpdateAvailable = true;
	// 	}

	// 	this.contentUpdateChecked = true;

	// 	// check if update dialog needs to be shown
	// 	this.updateDialogDateCheck();
	// }

	// open dialog asking the user to update binary
	updateBinary(): void {
		if (!APP_CONFIG.binary_updates) {
			return;
		}

		let alert = this.alertController.create({
			title: 'Update available',
			message: `Please keep your app up to date by downloading and installing the latest version.<br><br>You have version ${this.currentDeployVersionString()}<br><br>The latest version is ${this.latestVersionString()}`,
			buttons: [
				{
					text: 'Not now',
					role: 'cancel'
				},
				{
					text: 'Download',
					handler: () => {
						this.startUpdateBinary();
					}
				}
			]
		});

		alert.present();
	}

	// open the appropriate app file from the server for user to install
	private startUpdateBinary(): void {
		if (!APP_CONFIG.binary_updates) {
			return;
		}

		if (this.platform.is('android')) {
			this.openInAppBrowser(`https://apps.media4learning.co.nz/av/app/${this.latestVersion}/AVCPG.apk`, true);
		} else if (this.platform.is('cordova') && !this.platform.is('android')) {
			this.inAppBrowser.create(`itms-services://?action=download-manifest&amp;url=https://apps.media4learning.co.nz/av/app/${this.latestVersion}/AVCPG.plist`, '_system', 'location=no,toolbar=no,hidden=yes');
		}
	}

	// // open dialog asking user to update content
	// updateContent(): void {
	// 	if (!APP_CONFIG.content_updates) {
	// 		return;
	// 	}

	// 	let alert = this.alertController.create({
	// 		title: 'New content available',
	// 		message: 'Please keep your app up to date with the latest content.',
	// 		buttons: [
	// 			{
	// 				text: 'Not now',
	// 				role: 'cancel'
	// 			},
	// 			{
	// 				text: 'Download',
	// 				handler: () => {
	// 					this.startUpdateContent();
	// 				}
	// 			}
	// 		]
	// 	});

	// 	alert.present();
	// }

	// start download of new content
	// private startUpdateContent(): void {
	// 	if (!APP_CONFIG.content_updates) {
	// 		return;
	// 	}

	// 	if (this.platform.is('cordova')) {
	// 		let loader = this.loadingController.create({
	// 			content: 'Please do not close this app. The app will restart when the download has completed.'
	// 		});

	// 		loader.present();

	// 		// get new content
	// 		DeployUpdate(APP_CONFIG.update_app_id, APP_CONFIG.update_channel_name, (error) => {
	// 			console.log(error);
	// 		});
	// 	}
	// }

	// private async startUpdateContent() {
	// 	if (this.platform.is('cordova')) {
	// 		let loader = this.loadingController.create({
	// 			content: 'Please do not close this app. The app will restart when the download has completed.'
	// 		});

	// 		loader.present();

	// 		// get new content
	// 		try {
	// 			await Pro.deploy.downloadUpdate((progress) => {
	// 				loader.setContent(`Downloading: ${progress}%`);
	// 			});

	// 			await Pro.deploy.extractUpdate((progress) => {
	// 				loader.setContent(`Extracting: ${progress}%`);
	// 			});

	// 			await Pro.deploy.reloadApp();
	// 		} catch(err) {

	// 		}
	// 	}
	// }

	private updateDialogDateCheck(): void {
		// check that both update checks have been performed, and there is at least one update available
		if (
			(this.binaryUpdateChecked || !APP_CONFIG.binary_updates) &&
			(this.contentUpdateChecked || !APP_CONFIG.content_updates) &&
			(this.isBinaryUpdateAvailable || this.isContentUpdateAvailable)
		) {
			// get today's date
			let today = new Date().toDateString();

			// get date of last update check
			this.nativeStorage.getItem('updatePopupDate').then(
				(data) => {
					// make sure the date is different so it will only ask to update once a day
					if (data !== today || this.forceUpdatePopupRegardlessOfDate) {
						this.openUpdateDialog(today);
					}
				},
				() => {
					// if there is no saved date - show the update dialog
					this.openUpdateDialog(today);
				}
			);
		}
	}

	private openUpdateDialog(today: string): void {
		// save date of this update check
		this.nativeStorage.setItem('updatePopupDate', today);

		// show the binary update dialog - or the content update dialog if there is no binary update
		if (this.isBinaryUpdateAvailable && APP_CONFIG.binary_updates) {
			this.updateBinary();
		}
		// else if (this.isContentUpdateAvailable && APP_CONFIG.content_updates) {
		// 	this.updateContent();
		// }
	}

	openInAppBrowser(url: string, openInSystemBrowser: boolean = false): void {
		let target = openInSystemBrowser ? '_system' : '_blank';
		this.inAppBrowser.create(url, target, 'location=no,toolbarposition=top');
	}
}



// WEBPACK FOOTER //
// ./src/services/update.service.ts